module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/creditcard-toolbox-6bb50e1ef8b7563f0c143c39414db57b.svg";